/*
    Arquivo utils que conterá todas as funções úteis
    para o funcionamento do sistema web.

    Criado por: Luiz Trindade.
*/

import Swal from 'sweetalert2';
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css"
import localforage from 'localforage';
import CryptoJS from 'crypto-js';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

//Luiz Trindade - Função de alerta
export function informar(mensagem) {
    Toastify({
        text: mensagem,
        duration: 3000,
        close: true,
        stopOnFocus: true,
        style: {
            background: "linear-gradient(to right, #00b09b, #96c93d)",
        },
    }).showToast();
}

//Luiz Trindade - Função para validação de email
export function validarEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

//Luiz Trindade - Função para armazenamento de dados
export function armazenarDado(chave, valor) {
    localforage.setItem(chave, valor)
        .then(() => {
            return 0;
        })
        .catch((error) => {
            console.error("Erro ao armazenar informação: ", error);
        });
}

//Luiz Trindade - Função para recuperação de dados
export function recuperarDado(chave) {
    localforage.getItem(chave)
        .then((value) => {
            return value;
        })
        .catch((error) => {
            console.error("Erro ao armazenar informação: ", error);
        });
}

//Luiz Trindade - Função para gerar um hash SHA256
export function gerarHash(texto) {
    return CryptoJS.SHA256(texto).toString(CryptoJS.enc.Hex);
}

//Luiz Trindade - Função para verificar se um texto é um hash SHA256 ou não
export function verificarHash(texto) {
    const sha256Regex = /^[a-fA-F0-9]{64}$/;
    return sha256Regex.test(texto);
}

//Luiz Trindae - Função que inicia ou para o loader
export function loader(param) {
    if (param == "start") {
        NProgress.start();
    } else {
        NProgress.done();
    }
}